module.exports = __webpack_public_path__ + "img/0007.55dd7189.png";